import { ChangeDetectionStrategy, Component, Input, SimpleChanges, inject } from '@angular/core';
import { AttributeResource } from '@df/catalog/attribute/attribute.resource';
import { IProductDataV2 } from '@df/catalog/product/product';
import { CustomerModel } from '@df/session/api/customer.model';
import { HTMLBindingDirective } from '@df/ui/common/html-binding.directive';
import { UiComponent } from '@df/ui/ui.component';
import { ProductDecorator } from '../../catalog/model/product/product.decorator';
import { NListingLabel } from './listing-label.cms-config';
import { ListingLabelService } from './listing-label.service';

@Component({
    selector: 'listing-label',
    templateUrl: './listing-label.component.html',
    styleUrl: './listing-label.component.scss',
    standalone: true,
    imports: [HTMLBindingDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListingLabelComponent extends UiComponent {
    @Input({
        required: true
    })
    product?: ProductDecorator<IProductDataV2>;

    @Input()
    displayDefault = false;

    @Input()
    showFullLabel = false;

    @Input()
    customClass?: string;

    private listingLabelService = inject(ListingLabelService);
    private attributeResource = inject(AttributeResource);
    private customerModel = inject(CustomerModel);

    enabled = false;
    label?: string;
    style?: NListingLabel.ILabelStyle;

    override ngOnInit() {
        this.subscriptions.add(this.customerModel.obs.status.subscribe(() => this.setLabels()));
        super.ngOnInit();
    }

    override ngOnChanges(changes: SimpleChanges) {
        if (changes['product']) {
            this.setLabels();
        }

        super.ngOnChanges(changes);
    }

    private setLabels() {
        if (this.displayDefault) {
            this.style = {
                textColor: this.product?.labelColor || null,
                bgColor: null
            };

            this.label = this.showFullLabel ? this.product?.label : this.product?.labelShort;

            if (this.product?.labelColorCustomer) {
                this.style = {
                    textColor: this.product?.labelColorCustomer || null,
                    bgColor: null
                };

                this.label = this.showFullLabel? this.product?.labelCustomer : this.product?.labelShortCustomer;
            }
        } else {
            const listingLabelValue = this.product?.getListingLabel();
            const listingLabelCustomerValue = this.product?.getListingLabelCustomer();
            const style = listingLabelValue ? this.listingLabelService.getLabelStyle(listingLabelValue) : undefined;
            const styleCustomer = listingLabelCustomerValue
                ? this.listingLabelService.getLabelStyleCustomer(listingLabelCustomerValue)
                : undefined;

            if (listingLabelCustomerValue && styleCustomer) {
                this.style = styleCustomer;
                this.label = this.product?.labelShortCustomer;
            } else {
                this.style = style;
                this.label = listingLabelValue
                    ? (this.showFullLabel ? this.product?.label : this.product?.labelShort) ||
                      (this.attributeResource.getExisting('listing_label')?.getOptionLabel(listingLabelValue) as string)
                    : undefined;
            }
        }

        this.enabled = !!this.style && !!this.label && this.listingLabelService.enabled;

        this.detectChanges();
    }
}
